import router from "@/router";
import store from "@/store";
import {set, get } from "@/utils/localStorage";
import request from "@/request";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import qs from 'qs'
import { Message } from 'element-ui'
import {channelCodeName} from '@/config';

router.beforeEach((to, from, next) => {

    let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );

    //充值路径优化，回调到各项目
    if(get('callBackUrl',3600000)){
        if(to.path =='/order/orderList'){
            let url=get('callBackUrl');
            localStorage.removeItem("callBackUrl");
            window.location.href=decodeURIComponent(url)
        }
        if(to.path !=='/userAccount/wxPay' && to.path !=='/order/orderList' && to.path !=='/userAccount/buy/rules' && to.path!=='/userAccount/buy/refundPolicy'){//微信支付扫码页,计费/退费规则页，订单列表页
            localStorage.removeItem("callBackUrl");
        }
    }

    if(to.path =='/userAccount/buy/paySuccess'){
        if (flag) {
            window.location.href = process.env.VUE_APP_ACCOUNTMOBILE + '/userAccount/paySuccess?'+qs.stringify(to.query);
            return false;
        }
    }

    //退款详情页面跳转H5的判断
    if(to.path =='/userAccount/refund'){
        if (flag) {
            window.location.href = process.env.VUE_APP_ACCOUNTMOBILE + '/userAccount/refund?'+qs.stringify(to.query);
            return false;
        }
    }
    if(to.path =='/userAccount/return'){
        if (flag) {
            window.location.href = process.env.VUE_APP_ACCOUNTMOBILE + '/userAccount/return?'+qs.stringify(to.query);
            return false;
        }
    }

    //案源律师认证跳到实名认证页面重定向到H5逻辑
    if (to.path == '/userCenter/AuthenticationName/Individual') {
        if (flag && to.query.from==='lawcase') {
            window.location.href = process.env.VUE_APP_ACCOUNTMOBILE + '/realName/individualsApply?'+qs.stringify(to.query);
            return false;

        }
    }
    //购买页跳转H5的判断
    if(to.path =='/userAccount/buy'){
        if (flag) {
            window.location.href = process.env.VUE_APP_ACCOUNTMOBILE+'/userAccount/buy'
            return false;
        }
    }

    if(to.path !=='/faceIsSuccess' && to.path !=='/enterpriseCation' && to.path !=='/invoice/download'){
        if (flag) {
            window.location.href = process.env.VUE_APP_ACCOUNTMOBILE + '/Home';
            return false;
        }
    }

    if (to.path == '/Home') {
        setTimeout(() => {
            let _hmt = _hmt || [];
            (() => {
                document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
                let hm = document.createElement('script');
                hm.src = "https://hm.baidu.com/hm.js?0c5b23c19976b092412ce05a3a7c64c7";
                hm.id = 'baidu_tj';
                let s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(hm, s);
            })();
        }, 50);
    } else {
        document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
    }

    store.dispatch('routerInfo/setRouter', { basicName: to.meta.basicName, basicRoute: router.options.routes, basicTitle: to.meta.title,  basicPath: to.path })


    NProgress.start();
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.meta.realTitle) {
        document.title = to.meta.realTitle
    }
    if (to.matched.length === 0) {
        //如果未匹配到路由
        from.name ? next({ name: from.name }) : next('/');
        //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    }
    const loginPath = [
        '/faceIsSuccess',
        '/invoice/download'
    ];
    let queryData = {};
    let queryParam = to.query;
    if (loginPath.indexOf(to.path) !== -1) {
        next();
        NProgress.done();
    } else {
        request({
            method: 'post',
            url: '/me',
        }).then((res) => {
            console.log(res)
            zhuge.identify(res.data.id)
            let id = get('userData') ? get('userData').id : ''
            if (id != res.data.id) {
                localStorage.removeItem('queryData');
            }
            let obj = Object.keys(queryParam)
            if (obj.length !== 0) {
                if(queryParam.clientId){
                    queryParam.sourceType=queryParam.clientId;
                }else if(queryParam.sourceType){
                    queryParam.clientId=queryParam.sourceType;
                }
                if(queryParam.sourceType && !/^[0-9]{6}$/.test(queryParam.sourceType)){
                    delete queryParam.sourceType;
                }
                Object.assign(queryData, get('queryData'), queryParam)
                set("queryData", queryData);
                if(queryData[channelCodeName]){//渠道码未来埋点用
                    store.commit('config/setChannelCodeValue', queryData[channelCodeName]);
                }
            }
            set("userData", res.data);
            store.commit('userInfo/setuserinfo', res.data);
            store.commit('userInfo/setBaseinfo', res.data);
            if (to.meta.isparent && res.data.parentId !== '0') {
                next({
                    path: '/userCenter/userInfo',
                });
            } else {
                // 子账号拦截去充值页
                if(res.data.parentId !== '0' && to.path == '/userAccount/buy'){
                    Message({
                        message: '暂不支持子账号充值，请联系主账号',
                        type: "error",
                        duration:5000
                    })
                    next({
                        path: '/Home',
                    });
                }else{
                    if(to.query.access_token){
                        let obj=to.query;
                        delete obj.access_token
                        next({
                            path:to.path,
                            query:obj
                        })
                    }else{
                        next();
                    }  
                }
                NProgress.done();
            }
            //获取律师状态
            store.dispatch('lawyer/getLawyerStatus')
        }).catch((err) => {
            console.log(err);
            localStorage.removeItem('queryData');
            // window.location.href = '/api/login?redirectUrl=' + encodeURI(window.location.href)
            window.location.href = process.env.VUE_APP_USERCENTERUI + '/login?redirectUrl=' + encodeURIComponent(window.location.href)
        })
    }

})